"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import { useProgressNavigation } from "@/components/progress-bar";
import { SiteMapItem, getRelativePath, providerSiteMap } from "@/config/sitemap";
import { useHomeRoute } from "@/hooks/use-home-route";
import { getRecentPages } from "@/lib/use-page-view-tracking";

/**
 * Find the name of a page by its route in the sitemap.
 */
function findPageName(items: SiteMapItem[], route: string): string | undefined {
  for (const item of items) {
    if (item.route === route) return item.name;
    if (item.children) {
      const childName = findPageName(item.children, route);
      if (childName) return childName;
    }
  }
  return undefined;
}
interface BackRouteInfo {
  route: string;
  text: string;
  hasRecentPage: boolean;
}

/**
 * Hook to manage back route navigation from settings/analytics pages.
 */
export function useBackRoute() {
  const $ = _c(8);
  const homeRoute = useHomeRoute();
  const {
    navigateWithProgress
  } = useProgressNavigation();
  let t0;
  if ($[0] !== homeRoute) {
    t0 = () => {
      const recentNonSettingsPage = getRecentPages().find(_temp);
      let backRoute;
      if (recentNonSettingsPage && getRelativePath(recentNonSettingsPage).length > 0) {
        backRoute = recentNonSettingsPage;
      } else {
        backRoute = homeRoute;
      }
      const pageName = findPageName(providerSiteMap, backRoute);
      return {
        route: backRoute,
        text: pageName ? `Back to ${pageName}` : "Back",
        hasRecentPage: !!recentNonSettingsPage && getRelativePath(recentNonSettingsPage).length > 0
      };
    };
    $[0] = homeRoute;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const getBackRouteInfo = t0;
  let t1;
  if ($[2] !== getBackRouteInfo || $[3] !== navigateWithProgress) {
    t1 = () => {
      const {
        route: route_0
      } = getBackRouteInfo();
      if (route_0) {
        navigateWithProgress(route_0);
      }
    };
    $[2] = getBackRouteInfo;
    $[3] = navigateWithProgress;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const handleBack = t1;
  let t2;
  if ($[5] !== getBackRouteInfo || $[6] !== handleBack) {
    t2 = {
      getBackRouteInfo,
      handleBack
    };
    $[5] = getBackRouteInfo;
    $[6] = handleBack;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(route) {
  return !route.includes("/settings") && !route.includes("/analytics") && !route.includes("/billing/dashboard") && !route.includes("/check-in/dashboard");
}
export { findPageName };